"use strict";


var deliveryAutocomplete;

import "jquery";
import "bootstrap/dist/js/bootstrap";
import "bootbox";
import "remodal";
import "bootstrap/less/bootstrap.less";
import "bootstrap/less/theme.less";
import "font-awesome/less/font-awesome.less";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "remodal/dist/remodal-default-theme.css";
import "remodal/dist/remodal.css"
import "./less/_main.less";

import Vue from "vue";
import VeeValidate from "vee-validate";
import VueResource from "vue-resource";
import AsyncComputed from "vue-async-computed";
import moment from "moment";
import "Common/bootstrap-datepicker.js";
import "slick-carousel";

window.$ = $;
window.bootbox = bootbox;

Vue.use(VeeValidate);
Vue.use(VueResource);
Vue.use(AsyncComputed);
VeeValidate.Validator.installDateTimeValidators(moment);

// Common dictionary updates
VeeValidate.Validator.updateDictionary({
	en: {
		messages: {
			required: () => "Required",
			digits: () => "Must be 5 digits only",
			numeric: () => "Numbers only",
			email: () => "Invalid email address",
			min_value: () => "Must be at least 1"
		}
	}
});

Vue.directive('datepicker', {
	bind: function (el, binding, vnode) {
		$(el).datepicker({
			autoclose: true,
			todayHighlight: true,
			format: "m/d/yyyy"
		}).on("changeDate", function (e) {
			Vue.set(vnode.context, binding.expression, e.format());
		});
	},
	update: function (el, binding) {
		if (binding.oldValue !== binding.value) {
			let tmp = binding.value === "" || binding.value === null ? null : new Date(binding.value);
			$(el).datepicker('setDate', tmp);
		}
	}
});

let products = window.model.Products;
for (var b = 0; b < products.length; b++) {
	products[b].Selected = false;
	products[b].QuoteCost = 0;
}
let addons = products.filter(p => {
	return !p.IsRequired && !p.IsStorageUnit;
});
let vm = null;

function initVue() {
	vm = new Vue({
		el: "#quoteContainer",
		data: {
			pickup: "",
			type: "",
			dateNeeded: moment().format("M/D/YYYY"),
			endDate: "",
			firstName: "",
			lastName: "",
			interest: "",
			phoneNumber: "",
			deliveryAddress: "",
			deliveryZip: "",
			email: "",
			comments: "",
			barrAddress: "1423 Planeview Dr",
			barrZip: "54904",
			distanceError: false,
			addOns: addons,
			submitting: false
		},
		computed: {
			duration() {
				if (this.dateNeeded == null || this.endDate == null || this.dateNeeded == "" || this.endDate == "") return 0;
				
				let start = new Date(this.dateNeeded);
				let end = new Date(this.endDate);

				let startMonth = start.getMonth();
				let endMonth = end.getMonth();
				let startDay = start.getDate();
				let endDay = end.getDate();
				let startYear = start.getFullYear();
				let endYear = end.getFullYear();
				let result = {
					months: 0,
					days: 0
				}

				// If the start and end years are not the same, increment the end month to account for the difference so that December/January is evaluated correctly
				if (endYear > startYear) endMonth += (12 * end.getFullYear() - start.getFullYear());

				// If the end month is greater than the start month, determine the difference
				if (endMonth > startMonth) {
					result.months = endMonth - startMonth;

					// If the start day-of-month is greater than the end day-of-month, then the difference between months should be one less than we just calculated
					if (startDay > endDay) {
						result.months--;
					}
				}

				// If we have more than one month, determine the number of additional days in the term
				if (result.months > 0) {

					// Copy the end date to a new object that we will use to calculate the remainder
					let startDate = new Date(start);

					// If the start day-of-month is greater than the end day-of-month, then we need to set the "remainder" start date for calculations to be in the month previous to the actual end date
					if (startDay > endDay) {
						// If our end month is January, then the start month needs to be December of the previous year
						if (end.getMonth() === 0) {
							startDate.setFullYear(endDate.getFullYear() - 1);
							startDate.setMonth(11); // Months are zero-based, December is "11"
						} else {
							// We are not crossing Dec-to-Jan, so just set the start month to be the month before the end month
							startDate.setMonth(end.getMonth() - 1);
						}
					} else {
						// The start day-of-month is same or less than the end day-of-month, so simply set the "remainder" start date to the same month
						startDate.setMonth(end.getMonth());
					}

					// Calculate the "remainder" days in the term
					result.days = this.daydiff(startDate, end);
				} else {

					// We are less than one month, so just calculate the difference in days
					result.days = this.daydiff(start, end);
				}
				return result;
			},
			requiredItems() {
				if (this.pickup === "0") {
					return products.filter(p => {
						return p.IsRequired;
					});
				} else {
					return products.filter(p => {
						return p.IsRequired && !p.IsPickupOnly;
					});
				}
			},

			// Costfor delivering the container to the first (delivery) site
			deliveryCost() {

				if (this.pickup === "1") {

					let distanceMultiplier = 2;

					// If the location is within the flat-rate delivery area, charge the flat rate, otherwise charge the per-mile rate
					// for the qualifying trips.
					return (window.model.Rates.FlatRateRadius <= 1 || this.deliveryDistance > window.model.Rates.FlatRateRadius)
						? this.deliveryDistance * distanceMultiplier * window.model.Rates.PerMileRate
						: window.model.Rates.FlatRate * distanceMultiplier;
				}
				return 0;
			},

			// Cost for required products
			requiredCost() {
				let cost = 0;
				for (var x = 0; x < this.requiredItems.length; x++) {
					this.requiredItems[x].QuoteCost = this.getRate(this.requiredItems[x]);
					cost += this.requiredItems[x].QuoteCost;
				}
				return cost;
			},

			renting() {
				return this.interest == '1';
			},

			// Cost for any add-ons
			addOnCost() {
				let cost = 0;
				for (var x = 0; x < this.addOns.length; x++) {
					if (this.addOns[x].Selected === true && (!this.addOns[x].IsPickupOnly || this.pickup === "0")) {
						this.addOns[x].QuoteCost = this.getRate(this.addOns[x]);
						cost += this.addOns[x].QuoteCost;
					} else this.addOns[x].QuoteCost = 0;
				}
				return cost;
			},

			totalEstimate() {
				return this.requiredCost + this.addOnCost + this.deliveryCost;
			},
			
			showEstimate() {
				if (!this.pickup) return false;
				if (this.deliveryAddress == "" || !/^\d{5}(?:[-\s]\d{4})?$/.test(this.deliveryZip)) return false;
				if (this.deliveryDistance <= 0) return false;
				return !this.distanceError && this.totalEstimate > 0;
			}
		},
		asyncComputed: {

			// Distance to first (delivery) site, measured from Barr.
			deliveryDistance() {

				// If the delivery address is not populated, do not calculate
				if (this.deliveryAddress == "" || !/^\d{5}(?:[-\s]\d{4})?$/.test(this.deliveryZip)) return Promise.resolve(0);

				return this.getDistance(this.barrAddress, this.barrZip, this.deliveryAddress, this.deliveryZip);
			}
		},
		watch: {
			dateNeeded(val) {
				let d = new Date(val);
				$("#endDate").datepicker('setStartDate', moment(d).add(1, 'days').format("M/D/YYYY"));
			}
		},
		filters: {
			asMoney(n) {
				var c = 2,
					d = ".",
					t = ",",
					s = n < 0 ? "-" : "",
					i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
					j = (j = i.length) > 3 ? j % 3 : 0;
				return "$" + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
			}
		},
		methods: {
			daydiff(first, second) {
				return Math.round((second - first) / (1000 * 60 * 60 * 24));
			},
			formatPhoneNum() {
				let x = this.phoneNumber.replace(/\D/g, '').match(/([2-9]\d{0,2})(\d{0,3})(\d{0,4})/);
				if (typeof (x) == "undefined" || x == null) return;
				this.phoneNumber = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
			},
			getDistance(originAddr, originZip, destAddr, destZip) {
				let self = this;

				return new Promise((resolve, reject) => {
					let origin = originAddr + " " + originZip;
					let destination = destAddr + " " + destZip;

					let service = new google.maps.DistanceMatrixService;
					service.getDistanceMatrix({
						origins: [origin],
						destinations: [destination],
						travelMode: "DRIVING",
						unitSystem: google.maps.UnitSystem.IMPERIAL,
						avoidHighways: false,
						avoidTolls: false
					}, (response, status) => {
						if (status !== 'OK') {
							reject("Error was: " + status);
						} else {
							let distance = Math.ceil(response.rows[0].elements[0].distance.value / 1609.34);

							if (window.model && window.model.Rates && window.model.Rates.MaxServiceRadius > 0 && window.model.Rates.MaxServiceRadius < distance) {
								self.distanceError = true;
							} else self.distanceError = false;

							resolve(distance);
						}
					});

				});
			},

			getRate(product) {

				let dateDiff = this.duration;

				//find best price
				//add days until the rate is greater than the week rate
				//then weeks days until the rate is greater than the month rate
				let day = 0;
				let week = 0;
				let month = dateDiff.months;
				if (month == 0) {
					dateDiff.days = Math.max(dateDiff.days, window.model.Rates.MinimumRentalTerm);
				}

				while (dateDiff.days > (day + (week * 7)) && month === dateDiff.months) {                
					let chunk = (day * product.DailyRate) > product.WeeklyRate
						|| (day * product.DailyRate) + (week * product.WeeklyRate) > product.MonthlyRate;

					if (!chunk) {
						day++;
					}

					if ((day * product.DailyRate) > product.WeeklyRate) {
						day = 0;
						week++;
					}

					if ((day * product.DailyRate) + (week * product.WeeklyRate) > product.MonthlyRate) {
						day = 0;
						week = 0;                    
						month++;
					}                
				}

				return (day * product.DailyRate) + (week * product.WeeklyRate) + (month * product.MonthlyRate);           
			},

			submitQuote() {
				var self = this;

				this.$validator.validateAll().then(() => {
					if (!self.distanceError) {
						var cart = self.requiredItems;
						self.addOns.forEach(a => {
							if (a.Selected && (self.pickup === "0" || !a.IsPickupOnly)) cart.push(a);
						});

						var rec = {
							IsPickup: self.pickup === "0",
							Type: self.type,
							DateNeeded: self.dateNeeded,
							EndDate: self.endDate,
							FirstName: self.firstName,
							LastName: self.lastName,
							Phone: self.phoneNumber,
							Street: self.deliveryAddress,
							Zip: self.deliveryZip,
							Email: self.email,
							QuoteCost: self.totalEstimate,
							Comments: self.comments,
							Distance: self.deliveryDistance,
							Interest: self.interest,
							products: cart
						}

						self.submitting = true;
						self.$http.post("/Home/Submit", rec).then(resp => {
							var data = resp.body;
							self.submitting = false;
							if (data) {
								self.pickup = "";
								self.type = "";
								self.dateNeeded = moment().format("M/D/YYYY");
								self.endDate = "";
								self.firstName = "";
								self.lastName = "";
								self.phoneNumber = "";
								self.deliveryAddress = "";
								self.deliveryZip = "";
								self.email = "";
								self.comments = "";
								self.interest = "";
								self.distanceError = false;
								$("#thanks").remodal().open();
								return;
							}
						}).catch(err => {
							self.submitting = false;
							console.error(err);
						});
					}
					
				}).catch(() => {
					console.log(self.errors);
				});
			}
		}
	});
}

$(document).ready(function () {  

	$('.image-strip').slick({
		dots: false,
		infinite: false,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 4,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3                  
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}         
		]
	});

	$(".small-image").off("click").on("click", function () {
		var videoContainer = $(".video-container");
		var imageContainer = $(".image-container");
		if ($(this).hasClass("video")) {
			imageContainer.hide();
			videoContainer.show();
			var video = "//www.youtube.com/embed/PHNXDrDn_pc?autoplay=1";
			var html = '<iframe src="' + video + '" frameborder="0" allowfullscreen></iframe>';
			requestAnimationFrame(function () {
				videoContainer.html(html);
			});
		} else {
			videoContainer.hide();
			imageContainer.show();            
			var smallImg = $("img", this);
			var largeImg = $("img", imageContainer);
			videoContainer.html("");

			largeImg.prop("src", smallImg.prop("src"));
		}        
	});

	//frmQuoteRequestValidator = frmQuoteRequest.validate(frmQuoteRequestValidateOpts);
});


window.initAutocomplete = function() {
	initVue();
	
	// Create the autocomplete object, restricting the search to geographical
	// location types.
	deliveryAutocomplete = new google.maps.places.Autocomplete((document.getElementById('deliveryAddress')), { types: ['geocode'] });

	// When the user selects an address from the dropdown, populate the address
	// fields in the form.
	deliveryAutocomplete.addListener('place_changed', fillInDeliveryAddress);

}

function fillInDeliveryAddress() {
	// Get the place details from the autocomplete object.
	var place = deliveryAutocomplete.getPlace();
	var addr = getPlaceAddr(place);

	vm.deliveryAddress = addr.streetAddr;
	vm.deliveryZip = addr.zipCode;
	vm.$validator.validate('deliveryAddress', addr.streetAddr);
	vm.$validator.validate('deliveryZip', addr.zipCode);
}

function getPlaceAddr(place) {
	var streetNum = "";
	var route = "";
	var postalCode = "";

	// Get each component of the address from the place details
	// and fill the corresponding field on the form.
	for (var i = 0; i < place.address_components.length; i++) {
		var addressType = place.address_components[i].types[0];
		if (addressType === "street_number") {
			streetNum = place.address_components[i]["short_name"];
		} else if (addressType === "route") {
			route = place.address_components[i]["long_name"];
		} else if (addressType === "postal_code") {
			postalCode = place.address_components[i]["short_name"];
		}
	}

	return {
		streetAddr: streetNum + " " + route,
		zipCode: postalCode
	}
}


// WEBPACK FOOTER //
// ./src/scripts.js